import {mobilemenu} from './mobilemenu';
import {header} from './header';
import {search} from './utilitysearch';
import {loginToggle} from './utilitylogin';
import { error } from 'laravel-mix/src/Log';

(function($) {

    window.$ = jQuery;

    $(document).ready(function(){
        header();
        search();
        loginToggle();
        mobilemenu();
        initLightbox();
        initResonsiveEmbed();
        initResponsiveTables();

        // Legacy Functions
        initJobBoard();
    });

    function setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
	}

	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	    }
	    return "";
	}

	function checkCookie() {
	    var user = getCookie("username");
	    if (user != "") {
	        alert("Welcome again " + user);
	    } else {
	        user = prompt("Please enter your name:", "");
	        if (user != "" && user != null) {
	            setCookie("username", user, 365);
	        }
	    }
    }

    window.__v = function(page_id){
        // no cookies? no flag
		if(!document.cookie) return;

		var ajaxurl = '/wp-admin/admin-ajax.php';

		// cast as string
		page_id = page_id.toString();

		var cookieName  = 'v1_act_page_views';
		var cookieValue = getCookie(cookieName);
		var isModified = false;

		// store a NEW cookie if one does not already exist
		if(!cookieValue.length) {
			cookieValue = JSON.stringify([page_id]);
			isModified 	= true;
		} else {
            // If cookie does exist get Cookie values, convert from JSON to Array.
            var page_ids = JSON.parse(cookieValue);

            // If current page isn't in arry add current post id to array, then convert back to JSON to store in the Cookie.
            if(!page_ids.includes(page_id)) {
                page_ids.push(page_id);
                cookieValue = JSON.stringify(page_ids);
                isModified = true;
            }
        }

        // If the cookie has been modified send request
        if(isModified) {
            $.post(ajaxurl,	{ 
                action : 'view_count', 
                data : page_id
            })
            .done(function() {
                // Only after the view count is updated save the cookie, this prevents the current cookie being loaded in PHP.
                setCookie(cookieName, cookieValue, 1);
            });
        }
    };
})(jQuery);


/**
 * Init Lightcase (lightbox)
 * http://cornel.bopp-art.com/lightcase/documentation/
 */
function initLightbox() {
    $('a[data-rel^=lightcase]').lightcase({
        maxWidth: 1024,
        maxHeight: 768
    });
}
function initResonsiveEmbed() {
    $('iframe[src*="youtube"], iframe[src*="vimeo"]').each(function(){
        $(this).addClass('embed-responsive-item')
            .wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
    });
}

function initResponsiveTables() {
    $('table').each(function(){
        $(this).addClass('table')
            .wrap('<div class="table-responsive"></div>');
    });
}

function initJobBoard() {
    let $jobs = $("#jobFeed");

    var numItems = 3;
    var jobsURL = "https://www.actuaries.asn.au/HQServices/Ads.svc/JobAds/GetJobAdsSummary?pageNumber=1&pageSize=" + numItems;

    //set loadimg state
    $jobs.addClass("loading");

    var jqxhr = $.ajax({
        url: jobsURL,
        type:"GET",
        dataType:"json"
    })
    .done(function(data, textStatus, jqXHR){
        var content = "";
        if(data.content && data.content.length) {
            for(var i=0;i<data.content.length;i++) {
                var ad = data.content[i];

                content += `<div class="job relative pb-6 mb-6">
                                <h4 class="font-bold"><a href="${ad.url}">${ad.title}</a></h4>
                                <p class="uppercase italic text-xs">${ad.companyName}</p>
                                <p class="text-sm">${ad.shortDescription}</p>
                            </div>`;
            }
            $jobs.html(content);
        } else {
            $jobs.html("<p>No results currently</p>");
        }
    })
    .fail(function(jqXHR, textStatus, errorThrown){
        $jobs.html('<p>Unable to retrieve jobs. Please try again later.</p>');
    })
    .always(function(){
        $jobs.removeClass("loading");
    });
}